import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import InputLabel from '@material-ui/core/InputLabel'
import Input from '@material-ui/core/Input'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControl from '@material-ui/core/FormControl'
import Divider from '@material-ui/core/Divider'
import Grid from '@material-ui/core/Grid'
import Select from '@material-ui/core/Select'
import Typography from '@material-ui/core/Typography'
import { currencySymbolMap } from 'currency-symbol-map'
import validate from '../ValidationHelpers'
import moment from 'moment-timezone'
import { countries } from 'countries-list'

const styles = theme => ({
  formControl: {
    margin: `0 ${theme.spacing.unit}px`,
    minWidth: 140,
    minHeight: 42
  }
})

export default withStyles(styles)(
  class LeftFormComponent extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      handleChange: PropTypes.func.isRequired,
      timeZone: PropTypes.string,
      currency: PropTypes.string,
      email: PropTypes.string,
      lastName: PropTypes.string,
      firstName: PropTypes.string,
      country: PropTypes.string
    }
    static defaultProps = {
      timeZone: '',
      currency: 'EUR',
      email: '',
      lastName: '',
      firstName: '',
      country: ''
    }
    state = {
      errors: {}
    }
    countriesList = Object.keys(countries)
      .map((key, index) => ({ ...countries[key], key: key }))
      .sort((a, b) => {
        if (a.name < b.name) return -1
        if (a.name > b.name) return 1
        return 0
      })

    handleChange = name => e => {
      let errorMessage = validate(name, e.target.value).errorMessage
      const newState = { ...this.state }
      if (name === 'country') {
        const currencyValue = countries[e.target.value].currency
        this.props.handleChange('currency', currencyValue)
        newState.errors.currency = validate(
          'currency',
          currencyValue
        ).errorMessage
      }
      newState.errors[name] = errorMessage
      this.props.handleChange(name, e.target.value)
      this.setState(newState)
    }

    render() {
      const {
        classes,
        email,
        lastName,
        firstName,
        timeZone,
        currency,
        country
      } = this.props
      const { errors } = this.state
      return (
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          alignContent="space-between"
          spacing={24}>
          <Grid item xs={11} sm={10} md={10}>
            <Typography variant="title">Utilisateur</Typography>
          </Grid>
          <Grid item xs={10} sm={9} md={9}>
            <Divider light />
          </Grid>
          <Grid item xs={10} md={10}>
            <FormControl fullWidth className={classes.formControl}>
              <InputLabel htmlFor="email-input">Email</InputLabel>
              <Input id="email-input" name="email" value={email} disabled />
            </FormControl>
          </Grid>
          <Grid item xs={10} md={5}>
            <FormControl fullWidth className={classes.formControl}>
              <InputLabel htmlFor="lastname-input">Nom</InputLabel>
              <Input id="lastname-input" value={lastName} disabled />
            </FormControl>
          </Grid>
          <Grid item xs={10} md={5}>
            <FormControl fullWidth className={classes.formControl}>
              <InputLabel htmlFor="firstname-input">Prénom</InputLabel>
              <Input id="firstname-input" value={firstName} disabled />
            </FormControl>
          </Grid>
          <Grid item xs={11} sm={10} md={10}>
            <Typography variant="title">Configuration Générale </Typography>
          </Grid>
          <Grid item xs={10} sm={9} md={9}>
            <Divider light />
          </Grid>
          <Grid item xs={10} md={10}>
            <FormControl
              error={!!errors.timeZone}
              required
              fullWidth
              className={classes.formControl}>
              <InputLabel htmlFor="tz-helper">Fuseau Horaire</InputLabel>
              <Select
                native
                value={timeZone}
                onChange={this.handleChange('timeZone')}
                input={<Input id="tz-helper" />}>
                <option value="" />
                {moment.tz.names().map((tz, i) => (
                  <option key={i} value={tz}>
                    {tz}
                  </option>
                ))}
              </Select>
              <FormHelperText>
                {errors.timeZone
                  ? errors.timeZone
                  : `Choisissez votre fuseau horaire`}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={10} md={10}>
            <FormControl
              error={!!errors.country}
              required
              fullWidth
              className={classes.formControl}>
              <InputLabel htmlFor="country-helper">Pays</InputLabel>
              <Select
                native
                value={country}
                onChange={e => {
                  this.handleChange('country')(e)
                  this.handleChange('currency')({
                    target: { value: countries[e.target.value].currency }
                  })
                }}
                input={<Input id="country-helper" />}>
                <option value="" />
                {this.countriesList.map((country, index) => (
                  <option key={country.key} value={country.key}>
                    {`${country.name}  ${country.emoji} `}
                  </option>
                ))}
              </Select>
              <FormHelperText>
                {errors.country ? errors.country : null}
              </FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={10} md={10}>
            <FormControl
              disabled
              required
              fullWidth
              className={classes.formControl}>
              <InputLabel htmlFor="currency-helper">Devise</InputLabel>
              <Select
                native
                value={currency}
                onChange={this.handleChange('currency')}
                input={<Input id="currency-helper" />}>
                <option value="" />
                {Object.keys(currencySymbolMap).map((key, i) => (
                  <option key={key} value={key}>{`${key} - ${
                    currencySymbolMap[key]
                  }`}</option>
                ))}
              </Select>
              <FormHelperText>
                La devise se met à jour en fonction du pays
              </FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      )
      // return
    }
  }
)



// WEBPACK FOOTER //
// ./src/routes/Boarding/components/GeneralInformations/LeftFormComponent/index.js